import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import ie from 'assets/windowsIcons/ie-paper.png';
import printer from 'assets/windowsIcons/17(32x32).png';
import go from 'assets/windowsIcons/290.png';
import links from 'assets/windowsIcons/links.png';
import search from 'assets/windowsIcons/299(32x32).png';
import favorite from 'assets/windowsIcons/744(32x32).png';
import back from 'assets/windowsIcons/back.png';
import earth from 'assets/windowsIcons/earth.png';
import edit from 'assets/windowsIcons/edit.png';
import forward from 'assets/windowsIcons/forward.png';
import history from 'assets/windowsIcons/history.png';
import home from 'assets/windowsIcons/home.png';
import mail from 'assets/windowsIcons/mail.png';
import msn from 'assets/windowsIcons/msn.png';
import refresh from 'assets/windowsIcons/refresh.png';
import stop from 'assets/windowsIcons/stop.png';
import windows from 'assets/windowsIcons/windows.png';
import dropdown from 'assets/windowsIcons/dropdown.png';

const HOME_URL = 'https://xlrtr.bandcamp.com/';

function normalizeAddress(value) {
  const trimmedValue = value.trim();
  if (!trimmedValue) return HOME_URL;
  if (/^(https?:|about:)/i.test(trimmedValue)) return trimmedValue;
  if (/^[\w.-]+\.[a-z]{2,}([/:?#].*)?$/i.test(trimmedValue)) {
    return `https://${trimmedValue}`;
  }
  return `https://www.google.com/search?q=${encodeURIComponent(trimmedValue)}`;
}

function isBlockedEmbedUrl(url) {
  try {
    return new URL(url).hostname.includes('instagram.com');
  } catch (e) {
    return false;
  }
}

function InternetExplorer({ onClose }) {
  const iframeRef = useRef(null);
  const [historyStack, setHistoryStack] = useState([HOME_URL]);
  const [historyIndex, setHistoryIndex] = useState(0);
  const [address, setAddress] = useState(HOME_URL);
  const [frameKey, setFrameKey] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const currentUrl = historyStack[historyIndex];
  const isEmbedBlocked = isBlockedEmbedUrl(currentUrl);
  const canGoBack = historyIndex > 0;
  const canGoForward = historyIndex < historyStack.length - 1;

  function navigate(value) {
    const nextUrl = normalizeAddress(value);
    setHistoryStack(prevHistory => [
      ...prevHistory.slice(0, historyIndex + 1),
      nextUrl,
    ]);
    setHistoryIndex(prevIndex => prevIndex + 1);
    setAddress(nextUrl);
    setIsLoading(true);
  }

  function goBack() {
    if (!canGoBack) return;
    const nextIndex = historyIndex - 1;
    setHistoryIndex(nextIndex);
    setAddress(historyStack[nextIndex]);
    setIsLoading(true);
  }

  function goForward() {
    if (!canGoForward) return;
    const nextIndex = historyIndex + 1;
    setHistoryIndex(nextIndex);
    setAddress(historyStack[nextIndex]);
    setIsLoading(true);
  }

  function goHome() {
    navigate(HOME_URL);
  }

  function refreshPage() {
    setFrameKey(prevKey => prevKey + 1);
    setIsLoading(true);
  }

  function stopLoading() {
    try {
      iframeRef.current.contentWindow.stop();
    } catch (e) {
      // Cross-origin frames can reject direct control.
    }
    setIsLoading(false);
  }

  function onSubmitAddress(e) {
    e.preventDefault();
    navigate(address);
  }

  function openCurrentUrl() {
    window.open(currentUrl, '_blank', 'noopener,noreferrer');
  }

  function onClickOptionItem(item) {
    switch (item) {
      case 'Close':
        onClose();
        break;
      case 'Home Page':
        goHome();
        break;
      case 'Back':
        goBack();
        break;
      case 'Refresh':
        refreshPage();
        break;
      case 'Stop':
        stopLoading();
        break;
      default:
    }
  }
  return (
    <Div>
      <section className="ie__toolbar">
        <div className="ie__options">
          <WindowDropDowns
            items={dropDownData}
            onClickItem={onClickOptionItem}
            height={21}
          />
        </div>
        <img className="ie__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="ie__function_bar">
        <div
          onClick={goBack}
          className={`ie__function_bar__button${canGoBack ? '' : '--disable'}`}
        >
          <img className="ie__function_bar__icon" src={back} alt="" />
          <span className="ie__function_bar__text">Back</span>
          <div className="ie__function_bar__arrow" />
        </div>
        <div
          onClick={goForward}
          className={`ie__function_bar__button${
            canGoForward ? '' : '--disable'
          }`}
        >
          <img className="ie__function_bar__icon" src={forward} alt="" />
          <div className="ie__function_bar__arrow" />
        </div>
        <div className="ie__function_bar__button" onClick={stopLoading}>
          <img className="ie__function_bar__icon--margin-1" src={stop} alt="" />
        </div>
        <div className="ie__function_bar__button" onClick={refreshPage}>
          <img
            className="ie__function_bar__icon--margin-1"
            src={refresh}
            alt=""
          />
        </div>
        <div className="ie__function_bar__button" onClick={goHome}>
          <img className="ie__function_bar__icon--margin-1" src={home} alt="" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button">
          <img
            className="ie__function_bar__icon--normalize "
            src={search}
            alt=""
          />
          <span className="ie__function_bar__text">Search</span>
        </div>
        <div className="ie__function_bar__button">
          <img
            className="ie__function_bar__icon--normalize"
            src={favorite}
            alt=""
          />
          <span className="ie__function_bar__text">Favorites</span>
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon" src={history} alt="" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin-1" src={mail} alt="" />
          <div className="ie__function_bar__arrow--margin-11" />
        </div>
        <div className="ie__function_bar__button">
          <img
            className="ie__function_bar__icon--margin12"
            src={printer}
            alt=""
          />
        </div>
        <div className="ie__function_bar__button--disable">
          <img className="ie__function_bar__icon" src={edit} alt="" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin12" src={msn} alt="" />
        </div>
      </section>
      <section className="ie__address_bar">
        <div className="ie__address_bar__title">Address</div>
        <form className="ie__address_bar__content" onSubmit={onSubmitAddress}>
          <img src={ie} alt="ie" className="ie__address_bar__content__img" />
          <input
            className="ie__address_bar__content__input"
            type="text"
            value={address}
            spellCheck={false}
            onChange={e => setAddress(e.target.value)}
          />
          <img
            src={dropdown}
            alt="dropdown"
            className="ie__address_bar__content__img"
          />
        </form>
        <button
          type="button"
          className="ie__address_bar__go"
          onClick={onSubmitAddress}
        >
          <img className="ie__address_bar__go__img" src={go} alt="go" />
          <span className="ie__address_bar__go__text">Go</span>
        </button>
        <div className="ie__address_bar__separate" />
        <div className="ie__address_bar__links">
          <span className="ie__address_bar__links__text">Links</span>
          <img
            className="ie__address_bar__links__img"
            src={links}
            alt="links"
          />
        </div>
      </section>
      <div className="ie__content">
        <div className="ie__content__inner">
          {isEmbedBlocked ? (
            <div className="ie__blocked-page">
              <img src={ie} alt="" />
              <h1>WINDOWS XLRTR.exe</h1>
              <p>Open this page in a browser tab.</p>
              <button type="button" onClick={openCurrentUrl}>
                Open Instagram
              </button>
              <div className="ie__blocked-url">{currentUrl}</div>
            </div>
          ) : (
            <>
              <iframe
                ref={iframeRef}
                key={`${frameKey}-${currentUrl}`}
                className="ie__browser-frame"
                src={currentUrl}
                title={currentUrl}
                frameBorder="0"
                onLoad={() => setIsLoading(false)}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
              <div className="ie__embed-note">
                Some modern sites block embedded browsers. Try another URL if
                the page refuses to load.
              </div>
            </>
          )}
        </div>
      </div>
      <footer className="ie__footer">
        <div className="ie__footer__status">
          <img className="ie__footer__status__img" src={ie} alt="" />
          <span className="ie__footer__status__text">
            {isEmbedBlocked
              ? 'Blocked by site'
              : isLoading
              ? 'Opening page...'
              : 'Done'}
          </span>
        </div>
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__right">
          <img className="ie__footer__right__img" src={earth} alt="" />
          <span className="ie__footer__right__text">Internet</span>
          <div className="ie__footer__right__dots" />
        </div>
      </footer>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .ie__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 100%;
    height: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
  }
  .ie__options {
    height: 23px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    padding-left: 2px;
    flex: 1;
  }
  .ie__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .ie__function_bar {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 1px 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .ie__function_bar__button {
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 3px;
    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 -1px 1px rgba(0, 0, 0, 0.1);
    }
    &:hover:active {
      border: 1px solid rgb(185, 185, 185);
      background-color: #dedede;
      box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      & > * {
        transform: translate(1px, 1px);
      }
    }
  }
  .ie__function_bar__button--disable {
    filter: grayscale(1);
    opacity: 0.7;
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
  }
  .ie__function_bar__text {
    margin-right: 4px;
  }
  .ie__function_bar__icon {
    height: 30px;
    width: 30px;
    &--normalize {
      height: 22px;
      width: 22px;
      margin: 0 4px 0 1px;
    }
    &--margin12 {
      height: 22px;
      width: 22px;
      margin: 0 1px 0 2px;
    }
    &--margin-1 {
      margin: 0 -1px;
      height: 30px;
      width: 30px;
    }
  }
  .ie__function_bar__separate {
    height: 90%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0 2px;
  }
  .ie__function_bar__arrow {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 4px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .ie__function_bar__arrow--margin-11 {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 1px 0 -1px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .ie__address_bar {
    border-top: 1px solid rgba(255, 255, 255, 0.7);
    height: 22px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px 2px;
    box-shadow: inset 0 -2px 3px -1px #2d2d2d;
  }
  .ie__address_bar__title {
    line-height: 100%;
    color: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
  .ie__address_bar__content {
    border: rgba(122, 122, 255, 0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    background-color: white;
    position: relative;
    margin: 0;
    &__img {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
    }
    &__img:last-child {
      width: 15px;
      height: 15px;
      right: 1px;
      position: absolute;
    }
    &__img:last-child:hover {
      filter: brightness(1.1);
    }
    &__input {
      min-width: 0;
      flex: 1;
      height: 18px;
      padding: 0 17px 0 2px;
      border: 0;
      outline: 0;
      color: #111;
      font-family: Tahoma, 'Noto Sans', sans-serif;
      font-size: 11px;
      overflow: hidden;
    }
  }
  .ie__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    border: 0;
    background: transparent;
    color: #111;
    font-family: Tahoma, 'Noto Sans', sans-serif;
    font-size: 11px;
    cursor: default;
    &__img {
      height: 95%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin-right: 3px;
    }
    &:hover {
      background: rgba(49, 106, 197, 0.12);
    }
  }
  .ie__address_bar__links {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    &__img {
      position: absolute;
      right: 2px;
      top: 3px;
      height: 5px;
      width: 8px;
    }
    &__text {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .ie__address_bar__separate {
    height: 100%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    box-shadow: 1px 0 rgba(255, 255, 255, 0.7);
  }
  .ie__content {
    flex: 1;
    overflow: auto;
    padding-left: 1px;
    border-left: 1px solid #6f6f6f;
    background-color: #f1f1f1;
    position: relative;
  }
  .ie__content__inner {
    position: relative;
    min-height: 100%;
    min-width: 100%;
    width: 100%;
    height: 100%;
  }
  .ie__browser-frame {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 360px;
    border: 0;
    background: #fff;
  }
  .ie__embed-note {
    position: absolute;
    left: 8px;
    right: 8px;
    bottom: 8px;
    padding: 5px 7px;
    color: #5d5d5d;
    background: rgba(255, 255, 225, 0.93);
    border: 1px solid #d1c891;
    font-size: 11px;
    pointer-events: none;
  }
  .ie__blocked-page {
    min-height: 100%;
    padding: 34px 38px;
    color: #111;
    background: #fff;
    font-family: Tahoma, 'Noto Sans', sans-serif;
    font-size: 12px;
  }
  .ie__blocked-page img {
    width: 32px;
    height: 32px;
    margin-bottom: 14px;
  }
  .ie__blocked-page h1 {
    max-width: 520px;
    margin: 0 0 12px;
    color: #00136b;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }
  .ie__blocked-page p {
    max-width: 520px;
    margin: 0 0 18px;
    line-height: 18px;
  }
  .ie__blocked-page button {
    min-width: 122px;
    height: 28px;
    padding: 0 14px;
    color: #111;
    background: linear-gradient(to bottom, #fff 0%, #ece9d8 100%);
    border: 1px solid #003c74;
    border-radius: 3px;
    font-family: inherit;
    font-size: 12px;
  }
  .ie__blocked-page button:hover {
    box-shadow: inset 0 0 0 1px #f3d074;
  }
  .ie__blocked-url {
    max-width: 100%;
    margin-top: 16px;
    color: #666;
    overflow-wrap: anywhere;
  }
  .ie__footer {
    height: 20px;
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 3px rgba(50, 50, 50, 0.8);
    background-color: rgb(236, 233, 216);
    display: flex;
    align-items: center;
    padding-top: 2px;
  }
  .ie__footer__status {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 2px;
    &__text {
      font-size: 11px;
    }
    &__img {
      height: 14px;
      width: 14px;
      margin-right: 3px;
    }
  }
  .ie__footer__block {
    height: 85%;
    width: 22px;
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: inset 1px 0 rgba(255, 255, 255, 0.7);
  }
  .ie__footer__right {
    display: flex;
    align-items: center;
    width: 150px;
    height: 80%;
    border-left: 1px solid rgba(0, 0, 0, 0.11);
    box-shadow: inset 1px 0 rgba(255, 255, 255, 0.7);
    padding-left: 5px;
    position: relative;
    &__text {
      font-size: 11px;
    }
    &__img {
      height: 14px;
      width: 14px;
      margin-right: 3px;
    }
    &__dots {
      position: absolute;
      right: 11px;
      bottom: -1px;
      width: 2px;
      height: 2px;
      box-shadow: 2px 0px rgba(0, 0, 0, 0.25), 5.5px 0px rgba(0, 0, 0, 0.25),
        9px 0px rgba(0, 0, 0, 0.25), 5.5px -3.5px rgba(0, 0, 0, 0.25),
        9px -3.5px rgba(0, 0, 0, 0.25), 9px -7px rgba(0, 0, 0, 0.25),
        3px 1px rgba(255, 255, 255, 1), 6.5px 1px rgba(255, 255, 255, 1),
        10px 1px rgba(255, 255, 255, 1), 10px -2.5px rgba(255, 255, 255, 1),
        10px -6px rgba(255, 255, 255, 1);
    }
  }
`;

export default InternetExplorer;
